// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles_icon__eYnbf {\n  cursor: pointer;\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n\n.styles_container__pnqPM {\n  position: relative;\n}", "",{"version":3,"sources":["webpack://./src/components/DateInput/styles.module.scss"],"names":[],"mappings":"AAAA;EACC,eAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AACD;;AACA;EACC,kBAAA;AAED","sourcesContent":[".icon {\n\tcursor: pointer;\n\tposition: absolute;\n\tright: 10px;\n\ttop: 10px;\n}\n.container {\n\tposition: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "styles_icon__eYnbf",
	"container": "styles_container__pnqPM"
};
export default ___CSS_LOADER_EXPORT___;
